
export { default as LinkExternal } from "./LinkExternal"